import Member from '../member/@config/router';
import PermissionGroup from '../permissionGroup/@config/router';

export default {
    path: 'admin',
    component: () => import('../Admin.vue'),
    children: [
        Member,
        PermissionGroup,
    ]
};